module.exports = __webpack_public_path__ + "static/portico_06-7467af146fe606bf0567d9c96cdbb9df.jpg";